import React, { useEffect } from 'react';
import { useApp } from '../../context/AppContext';

const SiteIdentity = () => {
  const { settings } = useApp();

  useEffect(() => {
    // Aktualizovat Title
    if (settings.site_title) {
      document.title = settings.site_title;
    }

    // Aktualizovat Meta Description
    if (settings.site_description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', settings.site_description);
    }
  }, [settings.site_title, settings.site_description]);

  return null; // Komponenta nic nevykresluje
};

export default SiteIdentity;
